import Api from '@/services/Api'

export default {
    cretateUsers(dati) {
        return Api().post('/users', dati);
    },

    getUserInfo(id) {
        return Api().get('/users/' +id);
    },

    getUsers() {
        return Api().get('/users');
    },

    updateInfoUser(id) {
        return Api().put('/users/' + id);
    },
}